import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Standalone pages do not necessarily render either public layout.
const PRIVATE_ROUTE = /^\/(?:admin|internalanalytics|cs-dashboard|dealbuilder-internal|tprs|media-creator|seogenerator|kundeportal|selvbetjening|ny-checkout|nycheckout|nycheckoutv2|detailedcheckout|detaljeret-checkout|checkout|app-survey|appsurvey|appsurveyadmin|surveyadmin|aiassistantadmin|opladereadmin|affiliate|upload|enkel-app|henvisningadmin|prisgaranti-app|prisgarantiapp|app-henvisning|henvisningapp|portal-prisgaranti|opladerbetaling|opladere\/admin|en\/(?:customer-portal|ny-checkout|app-guide))(?:\/|$)/i;
export function isPrivateRoute(path) {
  return PRIVATE_ROUTE.test(path);
}
export default function PrivateRouteMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!isPrivateRoute(pathname)) return;
    let tags = [...document.head.querySelectorAll('meta[name="robots"]')];
    let created;
    if (!tags.length) {
      created = document.createElement('meta');
      created.name = 'robots';
      document.head.appendChild(created);
      tags = [created];
    }
    const previous = tags.map(tag => tag.content);
    tags.forEach(tag => { tag.content = 'noindex, nofollow'; });
    return () => {
      tags.forEach((tag, index) => {
        if (tag === created) tag.remove();
        else if (tag.isConnected) tag.content = previous[index];
      });
    };
  }, [pathname]);
  return null;
}